module.exports = __webpack_public_path__ + "static/media/qualifing-icon.e27f581e.svg";